var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","name":_vm.model[_vm.field]},domProps:{"value":_vm.model[_vm.field]},on:{"input":function($event){return _vm.input($event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }